import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import * as tinycolor_ from 'tinycolor2';
const tinycolor = tinycolor_;

import { CssVarsTheme } from './branding';

interface Color {
  hex: string;
  darkContrast: boolean;
}

const Palettes = [
   'primary',
   'accent',
   'warn',
   'header',
   'success',
   'alert',
   'notification',
];

@Injectable({
   providedIn: 'root'
})
export class CssVarsService {
   private renderer: Renderer2;

   constructor( private factory: RendererFactory2, ) {
      this.renderer = this.factory.createRenderer( null, null );
   }

   setTheme( theme: CssVarsTheme ) {
      if ( !theme ) { return; }

      Object.keys( theme ).map( name => {
         if ( Palettes.includes( name )) {
          this.setPalette( name, theme?.[name] )
         } else {
            if(name == 'brand') {
               document.documentElement.setAttribute(name, theme?.[name]);
            }
            document.documentElement.style.setProperty( `--${name}`, theme?.[name] );
         }
      });

      this.renderer[!!theme?.isdark ? 'addClass' : 'removeClass'](document.documentElement, 'dark' );
   }

   setPalette( name: string, color: string ) {
      let palette = this.computeColors( color );

      palette = {
         ...palette,
         default: palette['500'],
         lighter: palette['100'],
         darker: palette['700']
      };

      Object.keys( palette ).map( key => {
         const color = palette[key];

         const key1 = `--${name}-${key}`;
         const value1 = color.hex;
         document.documentElement.style.setProperty(key1, value1);

         const key2 = `--${name}-contrast-${key}`;
         const value2 = color.darkContrast ? 'rgba(0, 0, 0, 0.87)' : 'white';
         document.documentElement.style.setProperty(key2, value2);
      });
   }

   computeColors( hex: string ): {[key: string]: Color } {
      return {
         50: this.getColorObject( tinycolor(hex).lighten(52).desaturate(52)),
         100: this.getColorObject( tinycolor(hex).lighten(37).desaturate(37)),
         200: this.getColorObject( tinycolor(hex).lighten(26).desaturate(26)),
         300: this.getColorObject( tinycolor(hex).lighten(12).desaturate(12)),
         400: this.getColorObject( tinycolor(hex).lighten(6).desaturate(6)),
         500: this.getColorObject( tinycolor(hex)),
         600: this.getColorObject( tinycolor(hex).darken(6)),
         700: this.getColorObject( tinycolor(hex).darken(12)),
         800: this.getColorObject( tinycolor(hex).darken(18)),
         900: this.getColorObject( tinycolor(hex).darken(24)),
      };
   }

   getColorObject( value: string ): Color {
      const c = tinycolor(value);

      return {
         hex: c.toHexString(),
         darkContrast: c.isLight()
      };
   }
}
